export default [
    {
        "id": 1874,
        "path": "/personal-banking/life-moments/secondary-school-programme/"
    },
    {
        "id": 1865,
        "path": "/services/foreign-exchange/foreign-currency-bank-draft-request/",
        "timeout": 60
    },
    {
        "id": 1866,
        "path": "/services/current-accounts/physical-security-key-order-form/"
    },
    {
        "id": 1875,
        "path": "/current-accounts/business/business-mandates/"
    },
    {
        "id": 1860,
        "path": "/bif-data-capture-form-hyundai/"
    },
    {
        "id": 1859,
        "path": "/bif-data-capture-form-kia/"
    },
    {
        "id": 1858,
        "path": "/insure-and-protect/protection/contact-us/"
    },
    {
        "id": 1857,
        "path": "/services/complaints/digital-complaints/"
    },
    {
        "id": 1856,
        "path": "/services/business/fatca-and-crs-self-certification-form-republic-of-ireland/"
    },
    {
        "id": 1855,
        "path": "/services/current-accounts/lodgement-book-ordering-form/"
    },
    {
        "id": 1854,
        "path": "/bank-at-work/roi-colleague-book-an-appointment/"
    },
    {
        "id": 1853,
        "path": "/current-accounts/personal/direct-debit-cancellation/"
    },
    {
        "id": 1852,
        "path": "/services/current-accounts/cancel-standing-order/"
    },
    {
        "id": 1848,
        "path": "/business-lending/small-business-loan-application-form/"
    },
    {
        "id": 1847,
        "path": "/services/customer-support/bereavement-notification-form/"
    },
    {
        "id": 1840,
        "path": "/business-lending/bif-callback-form/"
    },
    {
        "id": 1839,
        "path": "/services/customer-support/bereavement-support/"
    },
    {
        "id": 1837,
        "path": "/internal/services/branch-callback-form-for-direct/"
    },
    {
        "id": 1836,
        "path": "/services/investments/contact-us/"
    },
    {
        "id": 1828,
        "path": "/internal/onfido-sdk-test/"
    },
    {
        "id": 1825,
        "path": "/services/personal/gdpr-data-subject-access-rights-dsar-form/"
    },
    {
        "id": 1821,
        "path": "/services/insure-and-protect/insurance-callback/"
    },
    {
        "id": 1822,
        "path": "/services/current-accounts/request-a-callback/"
    },
    {
        "id": 1823,
        "path": "/services/business/bank-of-ireland-fxpay/"
    },
    {
        "id": 1820,
        "path": "/services/loans/motor-finance-enquiry/"
    },
    {
        "id": 1815,
        "path": "/services/current-accounts/change-of-name-on-account/"
    },
    {
        "id": 1810,
        "path": "/uk/services/mortgages/product-switch-form/"
    },
    {
        "id": 1832,
        "path": "/personal-banking/regularsaver/"
    },
    {
        "id": 1808,
        "path": "/services/help-centre/contact-us/"
    },
    {
        "id": 1803,
        "path": "/deposits/fixed-term/term-deposit-maturity-instruction/"
    },
    {
        "id": 1872,
        "path": "/services/marketing/marketing-preferences/"
    },
    {
        "id": 1867,
        "path": "/services/business/coin-order/"
    },
    {
        "id": 1845,
        "path": "/current-accounts/personal/smart-start-account/"
    },
    {
        "id": 1787,
        "path": "/services/account-closure/account-closure-call-back-form/"
    },
    {
        "id": 1772,
        "path": "/current-accounts/business/unincorporated-current-account/"
    },
    {
        "id": 1768,
        "path": "/services/fatca-and-crs-self-certification-form-republic-of-ireland/"
    },
    {
        "id": 1774,
        "path": "/consumer-lending/credit-cards/low-rate-instalment-plan-offer/instalment-plan-calculator/"
    },
    {
        "id": 1759,
        "path": "/services/complaints/bank-of-ireland-group-customer-complaints/"
    },
    {
        "id": 1760,
        "path": "/consumer-lending/credit-cards/credit-card-upgrade/"
    },
    {
        "id": 1769,
        "path": "/consumer-lending/credit-cards/credit-card-limit-increase/"
    },
    {
        "id": 1758,
        "path": "/consumer-lending/personal-loan-temporary-test/"
    },
    {
        "id": 1796,
        "path": "/business-lending/business-credit-card/"
    },
    {
        "id": 1756,
        "path": "/services/foreign-currency-order-form/"
    },
    {
        "id": 1755,
        "path": "/services/book-appointment/"
    },
    {
        "id": 1754,
        "path": "/current-accounts/book-appointment-current-account/",
        "timeout": 60
    },
    {
        "id": 1720,
        "path": "/business-on-line/change-of-administrator/"
    },
    {
        "id": 1728,
        "path": "/premier/premier-call-back/"
    },
    {
        "id": 1726,
        "path": "/uk/transaction-dispute/"
    },
    {
        "id": 1727,
        "path": "/uk/cancel-recurring-card-payment/"
    },
    {
        "id": 1819,
        "path": "/uk/deposits/fixed-term/classic-saver-fixed-term-deposit/"
    },
    {
        "id": 1818,
        "path": "/uk/current-accounts/personal/personal-current-account-gie/"
    },
    {
        "id": 1817,
        "path": "/uk/current-accounts/personal/personal-current-account-ssg/"
    },
    {
        "id": 1816,
        "path": "/uk/current-accounts/personal/personal-current-account-bcs/"
    },
    {
        "id": 1777,
        "path": "/uk/current-accounts/personal/personal-current-account-eligibility/"
    },
    {
        "id": 1718,
        "path": "/business-on-line/general-amendment-form/"
    },
    {
        "id": 1831,
        "path": "/deposits/fixed-term/advantage-fixed-term-deposit/"
    },
    {
        "id": 1812,
        "path": "/consumer-lending/credit-cards/"
    },
    {
        "id": 1833,
        "path": "/personal-banking/supersaver/"
    },
    {
        "id": 1813,
        "path": "/consumer-lending/credit-cards/additional-cardholder-form/"
    },
    {
        "id": 1735,
        "path": "/bank-at-work/book-an-appointment/"
    },
    {
        "id": 1698,
        "path": "/services/api/developer-contact/"
    },
    {
        "id": 1850,
        "path": "/internal/release-test-page-4/"
    },
    {
        "id": 1824,
        "path": "/current-accounts/business-partnership-current-account/"
    },
    {
        "id": 1783,
        "path": "/mortgages/mortgage-multi-services-form/"
    },
    {
        "id": 1692,
        "path": "/premier-onboarding/"
    },
    {
        "id": 1748,
        "path": "/services/transaction-dispute/"
    },
    {
        "id": 1744,
        "path": "/services/cancel-recurring-card-payment/"
    },
    {
        "id": 1683,
        "path": "/pensions/pension-campaign/"
    },
    {
        "id": 1773,
        "path": "/services/account-closure/"
    },
    {
        "id": 1671,
        "path": "/register-your-school-for-money-smarts-programme/"
    },
    {
        "id": 1745,
        "path": "/direct-debit-mandate/"
    },
    {
        "id": 1661,
        "path": "/baw/book-an-appointment/"
    },
    {
        "id": 1746,
        "path": "/current-accounts/personal-account-switching/"
    },
    {
        "id": 1646,
        "path": "/documents/upload-hub/"
    },
    {
        "id": 1737,
        "path": "/uk/current-accounts/business-sole-trader-current-account/"
    },
    {
        "id": 1640,
        "path": "/report-fraud/"
    },
    {
        "id": 1777,
        "path": "/uk/current-accounts/personal-current-account/"
    },
    {
        "id": 1631,
        "path": "/business-lending/finance/"
    },
    {
        "id": 1743,
        "path": "/business-lending/small-business-overdraft/"
    },
    {
        "id": 1742,
        "path": "/business-lending/small-business-loan/"
    },
    {
        "id": 1731,
        "path": "/current-accounts/business-sole-trader-current-account/"
    },
    {
        "id": 1662,
        "path": "/consumer-lending/personal-overdraft/"
    },
    {
        "id": 1829,
        "path": "/consumer-lending/personal-loan/"
    },
    {
        "id": 1862,
        "path": "/current-accounts/personal-current-account/"
    }
] as { path: string; id: number; timeout?: number; }[];
